import { render, staticRenderFns } from "./chanceDetail.vue?vue&type=template&id=46a4d7d6&scoped=true&"
import script from "./chanceDetail.vue?vue&type=script&lang=js&"
export * from "./chanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./chanceDetail.vue?vue&type=style&index=0&id=46a4d7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a4d7d6",
  null
  
)

export default component.exports